module.exports = {
  '/catalog': {
    appName: 'atlas-web',
    host:
      process.env.ATLAS_HOST || 'http://127.0.0.1:3000/api/rewrite/atlas-web',
  },
  '/deliveries': {
    appName: 'sonar',
    host: process.env.SONAR_HOST || 'http://127.0.0.1:3000/api/rewrite/sonar',
  },
  '/ppp': {
    appName: 'ppp-portal-ui',
    host:
      process.env.PPP_HOST || 'http://127.0.0.1:3000/api/rewrite/ppp-portal-ui',
  },
  '/upload': {
    appName: 'uplink-web2',
    host:
      process.env.UPLINK_HOST ||
      'http://127.0.0.1:3000/api/rewrite/uplink-web2',
  },
  '/forms': {
    appName: 's4mp-forms',
    host:
      process.env.S4MP_FORMS_HOST ||
      'http://127.0.0.1:3000/api/rewrite/s4mp-forms',
  },
};
